module.exports = __webpack_public_path__ + "static/wrplogo2d-94da771e264200998aef40626fe9bb1c.png";